import React from 'react'
import { type LicenseFulfillment } from '../license-lookup.types';
import { useTranslation } from 'react-i18next';
import FulfillmentItem from './FulfillmentItem';
import { debounce } from '../../common/js/search-utility';
import { LicenseLookupContext } from '../contexts/LicenseLookupContext';

const PAGE_SIZE = 15;

type Props = {fulfillments: LicenseFulfillment[]}

export default function FulfillmentTable({fulfillments }: Props) {
    const [pageNumber, setPageNumber] = React.useState(0);
    const [lookupState, setLookupState] = React.useContext(LicenseLookupContext);

    const { t } = useTranslation('account', {keyPrefix: 'account'})

    const maxPageCount = React.useMemo(() => {
        return Math.floor(fulfillments.length / PAGE_SIZE);
    }, [fulfillments])

    const hasNextPage = pageNumber < maxPageCount;
    const hasPreviousPage = pageNumber > 0;

    React.useEffect(() => {
        setPageNumber(0);
    }, [fulfillments])

    const items: React.JSX.Element[] = []
    for(let i = 0; i < PAGE_SIZE; i++){
        const start = PAGE_SIZE * pageNumber
        const f = fulfillments[start + i];
        if (!f){
            break;
        }
        items.push((
            <FulfillmentItem fulfillment={f} />
        ))
    }

    const nextPage = (e: React.MouseEvent<HTMLAnchorElement>) => {
        e.preventDefault();
        if (hasNextPage){
            setPageNumber(pageNumber + 1);
        }
    }

    const previousPage = (e: React.MouseEvent<HTMLAnchorElement>) => {
        e.preventDefault();
        if (hasPreviousPage){
            setPageNumber(pageNumber - 1);
        }
    }

    const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const query = event.currentTarget.value;
        const debounceFunc = debounce(doSearch, 750, false);
        debounceFunc(query);
    }

    const doSearch = (query: string) => {
        let result = lookupState.akey.fulfillments;
        if (query != '' && query != null){
            result = fulfillments.filter((f : LicenseFulfillment) => {
                return (
                    f.hostName.includes(query) ||
                    f.hostId.includes(query)
                );
            })
        }
        setLookupState({...lookupState, filteredFulfillments: result});
    }

    const nextSrc = hasNextPage ? '/svgs/next.svg' : '/svgs/next-disabled.svg';
    const previousSrc = hasPreviousPage ? '/svgs/previous.svg' : '/svgs/previous-disabled.svg';

    return (
        <div className='fulfillments-container box'>
            <div className='table-search'>
                <div className='form-field'>
                    <input name="fulfillment-search" placeholder='Search' onInput={handleSearchChange} />
                </div>
            </div>
            <div className='fulfillment-table-container'>
                <table className='bfx-table fulfillment-table'>
                    <thead>
                        <tr>
                            <th>{t('license.fulfillment.activated')}</th>
                            <th>{t('license.fulfillment.hostId')}</th>
                            <th>{t('license.fulfillment.hostName')}</th>
                            <th>{t('license.fulfillment.expires')}</th>
                            <th>{t('license.fulfillment.qty')}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {items}
                    </tbody>
                </table>
            </div>
            <div className='table-footer'>
                <div className='button-group fulfillment-navigation-buttons'>
                    <a href="#" onClick={previousPage}><img src={previousSrc} /></a>
                    <a href="#" onClick={nextPage}><img src={nextSrc} /></a>
                </div>
            </div>
        </div>
    )
}